import env from '~/env';

const devConsole = {
  log: (...args: unknown[]) => {
    if (env.NODE_ENV === 'development') {
      // biome-ignore lint/suspicious/noConsole: : We want this
      console.log('[dev]', ...args);
    }
  },
  info: (...args: unknown[]) => {
    if (env.NODE_ENV === 'development') {
      // biome-ignore lint/suspicious/noConsole: : We want this
      console.info('[dev]', ...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (env.NODE_ENV === 'development') {
      // biome-ignore lint/suspicious/noConsole: : We want this
      console.warn('[dev]', ...args);
    }
  },
  error: (...args: unknown[]) => {
    if (env.NODE_ENV === 'development') {
      // biome-ignore lint/suspicious/noConsole: : We want this
      console.error('[dev]', ...args);
    }
  },
};

function getCallerStack() {
  const stack = new Error().stack;
  if (!stack) return;
  const lines = stack.split('\n');
  const callerLine = lines[3] || lines[2]; // line 3/4 is the calling fn/file
  return callerLine?.trim();
}

export { devConsole, getCallerStack };
